// extracted by mini-css-extract-plugin
export default {"letter":"IconComponent_letter__s5M8F","icon":"IconComponent_icon__TeIRc","spin":"IconComponent_spin__jYHSY"};